import ModalComponent from './modalComponent';
import 'base_global_css/components/atcComp.scss';
export default class atcComp extends ModalComponent {
    constructor(...args) {
        super(...args);
        return this;
    }

    initialize() {
        let self = this;
        // click binding on modal button
        $('body').on('product:Added', (e, data) => {
            e.preventDefault();
            e.stopPropagation();
            self.el.dataset.modalurl = self.el.dataset.atcurl + `?pid=${data.pid}`;
            this.open(self.el.dataset.modalurl);
        });
    }
    
    onOpen() {
        let self = this;
        if (this.el.dataset.dependency) {
            PVH.mountAllComponents(this.el.dataset.dependency);
        }

        let $productPrice = $('.atc-modal__product-summary .ds-product-price .sales', this.$el);
        if($productPrice.length) {
            $productPrice.append(`<span>each</span>`);
        }

        const body = document.body;
        this.scrollPosition = window.scrollY;

        body.style.cssText = `
            overflow: hidden;
        `;

        $('body').on('modal:close', function() {
            const body = document.body;

            body.style.removeProperty('overflow');
            window.scrollTo(0, self.scrollPosition);
        });
    }

    enable() {
        if (!this.state.data) return;

        let div = document.createElement('div');
        div.innerHTML = this.state.data;
        let header = div.querySelector('#modalHeader');

        //update to modalComonent
        let modalHeader = `<span class="icon-checkmark"></span><span>${header.value}</span>`;
        this.createModal({
            body: this.state.data,
            header: modalHeader
        });
    }
}

